import { render, staticRenderFns } from "./InternalAgencyPageLimitsModal.vue?vue&type=template&id=609fb18e&scoped=true&"
import script from "./InternalAgencyPageLimitsModal.vue?vue&type=script&lang=js&"
export * from "./InternalAgencyPageLimitsModal.vue?vue&type=script&lang=js&"
import style0 from "./InternalAgencyPageLimitsModal.vue?vue&type=style&index=0&id=609fb18e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "609fb18e",
  null
  
)

export default component.exports